<script>
import { required } from "@vuelidate/validators";
import { zipCode } from "@/utils/form-validators";

import Button from "@/components/atoms/button";
import Form from "@/components/molecules/form";
import FormInput from "@/components/molecules/form-input";
import FormGroup from "@/components/molecules/form-group";
import FormSelect from "@/components/molecules/form-select";
import FormSelectOption from "@/components/molecules/form-select/form-select-option";
import FormFieldset from "@/components/molecules/form-fieldset";
import {
  formValidationProps,
  useFormValidation
} from "@/components/organisms/mixins/form-validation.mixin";

export default {
  name: "MesAdressesModifier",
  components: {
    Button,
    Form,
    FormInput,
    FormGroup,
    FormSelect,
    FormSelectOption,
    FormFieldset
  },
  props: {
    client: {
      type: Object,
      required: true
    },
    error: {
      type: Object,
      required: false,
      default: () => {}
    },
    ...formValidationProps()
  },
  emits: ["updateBillingAddress"],
  setup(props) {
    const { v$, getState, getErrorMessage, checkValidation } =
      useFormValidation(props);
    return {
      v$,
      getState,
      getErrorMessage,
      checkValidation
    };
  },
  data() {
    return {
      adresse: this.client.attributes.adresse,
      codePostal: this.client.attributes.cp,
      ville: this.client.attributes.ville,
      pays: this.client.attributes.pays,
      departement: this.client.attributes.departement,
      complementAdresse: this.client.attributes.complement_adresse
    };
  },
  validations() {
    return {
      adresse: {
        required
      },
      codePostal: {
        required,
        zipCode
      },
      ville: {
        required
      }
    };
  },
  methods: {
    save() {
      if (this.checkValidation(this.v$)) {
        this.$emit("updateBillingAddress", {
          adresse: this.adresse,
          cp: this.codePostal,
          ville: this.ville,
          pays: this.pays,
          departement: this.departement,
          complement_adresse: this.complementAdresse
        });
      }
    }
  }
};
</script>

<template>
  <div class="u-pr-sm u-pb-sm u-pl-sm">
    <div class="u-text-center">
      <h1 class="u-color-primary u-font-22 u-mb-md u-mt-md">
        Modifier votre adresse de facturation
      </h1>
      <Form :error="error">
        <FormFieldset
          center
          size="lg"
        >
          <FormGroup
            :state="getState(v$,'adresse')"
            class="u-mb-md"
          >
            <FormInput
              v-model="adresse"
              :value="client.attributes.adresse"
            >
              Adresse *
            </FormInput>
            <template #message>
              <p>
                {{ getErrorMessage("adresse","Merci de renseigner votre adresse") }}
              </p>
            </template>
          </FormGroup>
          <FormGroup
            :state="getState(v$,'complement_adresse')"
            class="u-mb-md"
          >
            <FormInput
              v-model="complementAdresse"
              :value="client.attributes.complement_adresse"
            >
              Complément
            </FormInput>
            <template #message>
              <p>
                {{ getErrorMessage("complement_adresse","Merci de renseigner un complement d'adresse valide") }}
              </p>
            </template>
          </FormGroup>
          <FormGroup
            :state="getState(v$,'codePostal')"
            class="u-mb-md"
            size="xs"
          >
            <FormInput
              v-model="codePostal"
              type="tel"
              :value="client.attributes.cp"
              size="xs"
              maxlength="10"
            >
              Code postal *
            </FormInput>
            <template #message>
              <p>
                {{ getErrorMessage("codePostal","Merci de renseigner un code postal valide") }}
              </p>
            </template>
          </FormGroup>
          <FormGroup
            :state="getState(v$,'ville')"
            class="u-mb-md"
          >
            <FormInput
              v-model="ville"
              :value="client.attributes.ville"
              :state="getState(v$,'ville')"
            >
              Ville *
            </FormInput>
            <template #message>
              <p>
                {{ getErrorMessage("ville","Merci de renseigner votre ville") }}
              </p>
            </template>
          </FormGroup>

          <FormGroup
            state="success"
            class="u-mb-md"
          >
            <FormSelect
              id="pays"
              v-model="pays"
              title="Pays"
              :value="client.attributes.pays"
            >
              <FormSelectOption value="France">
                France
              </FormSelectOption>
              <FormSelectOption value="Belgique">
                Belgique
              </FormSelectOption>
              <FormSelectOption value="Suisse">
                Suisse
              </FormSelectOption>
              <FormSelectOption value="Allemagne">
                Allemagne
              </FormSelectOption>
              <FormSelectOption value="Luxembourg">
                Luxembourg
              </FormSelectOption>
            </FormSelect>
          </FormGroup>

          <FormGroup
            class="u-mb-md"
            :state="getState(v$,'departement')"
          >
            <FormInput
              v-model="departement"
              :value="client.attributes.departement"
              :state="getState(v$,'departement')"
            >
              Etat / Département
            </FormInput>
            <template #message>
              <p>
                {{ getErrorMessage("departement","Ce nom de departement est invalide") }}
              </p>
            </template>
          </FormGroup>
          <Button
            variant="primary"
            radius="full"
            size="md"
            @click="save()"
          >
            Mettre à jour mon adresse
          </Button>
        </FormFieldset>
      </Form>
    </div>
  </div>
</template>

<style lang="scss" scoped>
</style>
